var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0253906 28.083C0.0253906 25.254 1.1492 22.5409 3.14959 20.5405C5.14997 18.5401 7.86308 17.4163 10.6921 17.4163C13.521 17.4163 16.2341 18.5401 18.2345 20.5405C20.2349 22.5409 21.3587 25.254 21.3587 28.083H18.6921C18.6921 25.9613 17.8492 23.9264 16.3489 22.4262C14.8486 20.9259 12.8138 20.083 10.6921 20.083C8.57032 20.083 6.53549 20.9259 5.0352 22.4262C3.53491 23.9264 2.69206 25.9613 2.69206 28.083H0.0253906ZM10.6921 16.083C6.27206 16.083 2.69206 12.503 2.69206 8.08301C2.69206 3.66301 6.27206 0.0830078 10.6921 0.0830078C15.1121 0.0830078 18.6921 3.66301 18.6921 8.08301C18.6921 12.503 15.1121 16.083 10.6921 16.083ZM10.6921 13.4163C13.6387 13.4163 16.0254 11.0297 16.0254 8.08301C16.0254 5.13634 13.6387 2.74967 10.6921 2.74967C7.74539 2.74967 5.35872 5.13634 5.35872 8.08301C5.35872 11.0297 7.74539 13.4163 10.6921 13.4163Z",
    fill: "#90A6CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.558cd849da50ad91e1c76a06e2fa5406.svg";
export { ForwardRef as ReactComponent };